module.exports = __webpack_public_path__ + "quality.oYK3CXOZ.svg";